const isStageEnv = () => {
    const url = window.location.host;
    return /hub-(stg|hml).xpi.com.br/.test(url);
};
  
  export default isStageEnv;
  